(() => {
  if (window.ProductDescriptionSpacing) { window.ProductDescriptionSpacing.refresh(); return; }
  function refresh() {
    document.querySelectorAll('section[id^="MainProduct-"] .section__richtext__editor p').forEach(paragraph => {
      const label = paragraph.firstElementChild;
      const isHeading = paragraph.children.length === 1 && label?.matches('strong,b') && paragraph.textContent.trim() === label.textContent.trim() && !!label.textContent.trim();
      let following = label?.nextSibling;
      while (following?.nodeType === Node.TEXT_NODE && !following.textContent.trim()) following = following.nextSibling;
      const startsSection = isHeading || (label?.matches('strong,b') && following?.nodeType === Node.ELEMENT_NODE && following.matches('br') && paragraph.firstChild === label);
      paragraph.classList.toggle('product-description-section-heading', isHeading);
      paragraph.classList.toggle('product-description-section-start', !!startsSection);
    });
  }
  window.ProductDescriptionSpacing = { refresh };
  refresh();
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
